export default {
  styleOverrides: {
    indicator: {
      height: 48,
      zIndex: -1,
      borderRadius: 24,
    },
  },
};
